/**
 * Presents the internal application foundation without simulating business data.
 */

import { GetBackofficeFoundationStatus } from "../GetBackofficeFoundationStatus";

/**
 * Renders the backoffice foundation status.
 */
export function SystemStatusPage() {
  const status = GetBackofficeFoundationStatus();

  return (
    <main className="min-h-screen bg-[var(--color-surface-canvas)] px-6 py-16 text-[var(--color-text-default)]">
      <section
        aria-labelledby="backoffice-title"
        className="mx-auto max-w-4xl rounded-[var(--radius-medium)] bg-[var(--color-surface-default)] p-8 shadow-sm"
      >
        <p className="text-sm font-semibold text-[var(--color-brand-primary)]">Operación interna</p>
        <h1
          className="mt-2 text-3xl font-bold text-[var(--color-brand-deep)]"
          id="backoffice-title"
        >
          {status.application} del Libro de Reclamos
        </h1>
        <p className="mt-4 text-[var(--color-text-muted)]">
          Cimientos listos para incorporar los módulos de negocio por entregas verticales.
        </p>
        <ul className="mt-8 grid gap-4 md:grid-cols-3">
          {status.capabilities.map((capability) => (
            <li
              className="rounded-[var(--radius-small)] bg-[var(--color-surface-subtle)] p-4 font-semibold text-[var(--color-brand-deep)]"
              key={capability}
            >
              {capability}
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
}
